<template>
<div class="login">
    <div class="login__header">
        <a href="/"><img src="@/assets/images/logo.svg" style="width: 200px;"></a>
    </div>
    <form v-on:submit.prevent="login()">
        <div class="login__content">
            <div class="login__label">
                <span>Tên đăng nhập</span>
            </div>
            <div class="login__row">
                <input v-model="username" autocapitalize="none" class="login__input" type="text" value="" placeholder="">
            </div>
            <div class="login__label">
                <span>Mật khẩu</span>
            </div>
            <div class="login__row">
                <input v-model="password" class="login__input" type="password" value="" placeholder="">
            </div>
            <span style="color: red;">{{mess}}</span>
        </div>
        <div class="login__bottom">
            <button v-if="!isLoading" class="login__button">Đăng nhập</button>
            <button v-else style="cursor: not-allowed;" class="login__button">Đang thực hiện ....</button>
        </div>
        <div class="login__bottom">
            <p class="" style="width: 100%;">
                <a style="float: left;text-decoration: underline;" href="/home"><i class="fas fa-home"></i>Về trang chủ</a>
                <!-- <a v-on:click="mode=1">Quên Mật Khẩu?</a> -->
            </p>
        </div>
    </form>
    <!-- <form v-else>
        <div class="login__content">
            <div class="login__label">
                <span>Email</span>
            </div>
            <div class="login__row">
                <input v-model="email" class="login__input" type="text" value="" placeholder="">
            </div>
            <code v-if="status==1">Email không được để trống</code>
            <span v-else-if="status==2">Chúng tôi đã gửi mật khẩu về email của Quý khách. Vui lòng kiểm tra!</span>
        </div>
        <div class="login__bottom">
            <button type="button" v-on:click="resetPassword" class="login__button">Gửi</button>
        </div>
    </form> -->
</div>
</template>

<script>
import User from "@/common/api/user"
import {saveToken, saveInfo} from "@/common/jwt"
import { LOGIN, SET_AUTH } from "@/store/actions.type";
export default {
  name: 'Login',
  data () {
    return {
       isLoading: false,
       status: 0,
       mode: 0,
       username: '',
       password: '',
       email: '',
       mess: '',
    }
  },
  methods: {
     resetPassword(){
        if (this.email == ''){
           this.status = 1;
           return;
        }
        User.resetPassword(this.email)
        .then(({ data }) => {
           this.status = 2
        })
     },
     login(){
        this.isLoading = true;
        User.login(this.username, this.password)
        .then(({ data }) => {
            this.mess = ''
           if (data.Message && data.Message != ''){
               this.mess = data.Message
               this.password = ''
               return;
           }
           if(data.Data){
            saveInfo({id: data.Data.id, username:this.username})
            saveToken(data.Data.token, data.Data.refresh_token)
            window.location.href = '/'
           }
        }).finally(() => {
            this.isLoading = false;
        });
     }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/Login.vue